import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { CompanyState } from '../../Store/companySlice';
import useCompany from './useCompany';

/**
 * White-label boot hook. On first mount, fetches /api/company/branding and
 * hydrates Redux + updates document.title + swaps favicon + publishes brand
 * color CSS variables. Runs BEFORE authentication so the login screen sees
 * the tenant's brand.
 *
 * All fetch + application logic lives in useCompany().refresh() so the
 * "post-Settings-save" refresh path uses the identical code path.
 */
export function useCompanyBoot(): void {
  const { refresh } = useCompany();
  const alreadyFetched = useRef(false);
  const hydrated = useSelector((s: any) => (s?.company as CompanyState | undefined)?.hydrated);

  useEffect(() => {
    if (alreadyFetched.current || hydrated) return;
    alreadyFetched.current = true;
    void refresh();
  }, [hydrated, refresh]);
}

export default useCompanyBoot;
